import React from 'react';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useTranslation } from 'next-i18next';
import hasAuthToken from 'lib/hasAuthToken';
import Layout from 'components/Layout';
import Link from 'next/link';

const DisclaimerPage = () => {
  const { t } = useTranslation();

  return (
    <Layout title={t('disclaimer.pageTitle')}>
      <div className="o-retain o-retain--lap u-margin-top-huge u-margin-bottom-huge">
        <h1>{t('disclaimer.pageHeading')}</h1>
        <p>
          <strong>Disclaimer</strong>
        </p>
        <p>
          deBanenSite.nl geeft geen garantie of zekerheid voor wat betreft de
          werking, kwaliteit of functionaliteit van de website. Toegang tot de
          website kan om wat voor reden dan ook verstoord, beperkt of vertraagd
          zijn. deBanenSite.nl geeft daarnaast geen garantie of zekerheid wat
          betreft de banen en de inhoud van het materiaal dat op de site
          verschijnt, de nauwkeurigheid, volledigheid, tijdloosheid of
          geschiktheid voor welk bepaald doeleinde dan ook.
        </p>
        <p>
          deBanenSite.nl aanvaardt geen enkele aansprakelijkheid voor schade van
          welke aard dan ook, mede daaronder begrepen gevolgschade (waaronder
          inbegrepen vertragingsschade en winstderving) door het gebruik of het
          onvermogen om gebruik te maken van deBanenSite.nl of enig materiaal
          dat op deBanenSite.nl verschijnt of van enige actie of besluit genomen
          als een resultaat van het gebruik van deBanenSite.nl of het
          desbetreffende materiaal.
        </p>
        <p>
          deBanenSite.nl bevat links naar externe websites. deBanensite.nl is
          niet aansprakelijk voor en heeft geen controle over de content van
          deze websites. Informatie op deBanenSite.nl of informatie beschikbaar
          gemaakt door middel van een hypertekst-link vanuit deBanensite.nl, is
          beschikbaar gemaakt zonder aansprakelijkheid van de kant van
          deBanenSite.nl.
        </p>
        <p>
          deBanensite.nl aanvaardt geen enkele aansprakelijkheid en
          verantwoordelijkheid in relatie tot informatie op of toegankelijk
          gemaakt vanaf deBanenSite.nl.
        </p>
        <p>
          deBanenSite.nl BV
          <br />
          KVKnr:&nbsp;37069600
          <br />
          BTWnr: NL8032.06.124B01
        </p>
        <p>
          <strong>Sollicitatiegegevens</strong>
        </p>
        <p>
          De sollicitatiegegevens worden bewaard, meer informatie zie onderdeel
          "opgeslagen informatie". Gegevens worden ook gebruikt om te informeren
          over diensten van deBanenSite.nl, CV-zoeken.nl en derden.
        </p>
        <p>
          Door te solliciteren via deBanenSite.nl gaat u akkoord met onze{' '}
          <Link href="/algemene-voorwaarden">Algemene Voorwaarden</Link>,{' '}
          <Link href="/privacy">Privacy</Link> en Disclaimer.
        </p>
        <p>
          deBanenSite.nl is geregistreerd bij College Bescherming
          Persoonsgegevens, Meldingsnummer 1397601
        </p>
        <p>
          Deze privacy statement is opgesteld om te laten zien dat
          deBanenSite.nl privacy hoog in het vaandel heeft. Deze privacy
          statement heeft betrekking op alle websites van deBanenSite.nl BV.
          deBanenSite.nl BV is exploitant van de site www.deBanenSite.nl. Op
          deze site worden werkgevers en werknemers de mogelijkheid geboden om
          met elkaar in contact te komen door het plaatsen van CV's en
          vacatures.
        </p>
        <p>
          deBanenSite.nl wil werken op basis van vertrouwen. Met dit vertrouwen
          willen wij helpen in de zoektocht naar een nieuwe baan. Om dit zoeken
          zo gemakkelijk mogelijk te maken verzamelen wij gegevens. Wij
          verzamelen deze gegevens zonder uw privacy in gevaar te brengen en
          gebruiken deze informatie alleen voor de in deze privacy statement
          aangegeven doeleinden.
        </p>
        <p>
          <u>
            <strong>
              Heeft u vragen of opmerkingen over deze privacy statement of over
              uw privacy neemt u dan contact op via info@debanensite.nl{' '}
            </strong>
          </u>
        </p>
        <p>
          <strong>
            Opgeslagen informatie
            <br />
          </strong>
        </p>
        <p>
          Om beter van dienst te kunnen zijn slaat de deBanenSite.nl informatie
          op.
        </p>
        <p>
          Bij het solliciteren via deBanenSite.nl verwerkt deBanenSite.nl de
          ingevoerde gegevens (zoals NAW - gegevens) evenals de meegestuurde
          gegevens.
        </p>
        <p>
          De opgeslagen informatie wordt zo toegankelijk voor werkgevers en / of
          intermediairs die de sites bezoeken op zoek naar geschikt personeel.
          Voor extra zichtbaarheid kunnen de gegevens ook beschikbaar worden
          gesteld (geëxporteerd) aan derden. Door het ter beschikking stellen
          van de gegevens stellen wij deze werkgevers en / of intermediairs en /
          of derden in staat om te kijken of zij een geschikte baan hebben en of
          zij contact kunnen opnemen. deBanenSite.nl is niet verantwoordelijk
          voor de naleving van privacy wetgeving door werkgevers en / of
          intermediairs en / of derden.
        </p>
        <p>deBanenSite.nl bestaat uit een netwerk van diverse websites.</p>
        <p>
          Bij Alert instellen worden uw gegevens in een beveiligde omgeving
          geplaatst, bij passende vacatures ontvangt u een e-mail.
        </p>
        <p>
          deBanenSite.nl is zodanig beveiligd dat er zonder inlogcodes niet in
          te loggen is. De beveiliging is te herkennen aan onze SSL EV
          certificaat, hierbij ziet de gebruiker in de browser de vermelding
          'https' in de URL, een gesloten slotje en de organisatienaam zoals in
          het KVK register is vermeld.
        </p>
        <p>
          <strong>Rechten en verantwoordelijkheden</strong>
        </p>
        <p>
          Gegevens kunnen worden verwijdert. Informatie over opgeslagen gegevens
          kunt u aanvragen via info@debanensite.nl. U heeft het recht om te
          allen tijde uw gegevens te verwijderen.
        </p>
        <p>
          deBanenSite.nl.nl heeft zonder nadere kennisgeving het recht om uw
          gegevens gedeeltelijk of geheel te verwijderen. U heeft geen recht om
          het opnemen van uw gegevens in onze database te eisen.
        </p>
        <p>
          U bent zelf verantwoordelijkheid voor de teksten en informatie die u
          aan ons verstrekt. Deze informatie mag niet in strijd zijn met welke
          wetgeving dan ook, bijvoorbeeld discriminatie wetgeving. U vrijwaart
          deBanenSite.nl van elke claim en vordering die tegen ons kan worden
          ingesteld doordat informatie die u ons verstrekt heeft, onrechtmatig
          is.
        </p>
        <p>
          <strong>
            Veiligheid en bescherming gegevens
            <br />
          </strong>
        </p>
        <p>
          deBanenSite.nl doet er op technisch gebied en binnen de eigen
          organisatie alles aan om uw veiligheid en privacy te garanderen.
        </p>
        <p>
          Klachten, stuur dan een e-mail naar info@debanensite.nl en omschrijf
          zo duidelijk mogelijk uw bevinding(en). <br />
          <br />
          Hoewel deBanenSite.nl niet aansprakelijk is neemt deBanenSite.nl
          klachten zeer serieus en zullen indien noodzakelijk contact opnemen
          met de betreffende opdrachtgever. Bij herhaaldelijke klachten kan
          deBanenSite.nl besluiten de aanbiedingen, links of banners van de
          opdrachtgever niet meer op de website te vermelden. <br />
          <br />
          Deze disclaimer is een aanvulling op de algemene voorwaarden van
          deBanenSite.nl BV tevens handelend onder deBanenSite.nl welke
          onverkort van toepassing zijn.
        </p>
        <p>
          In deze disclaimer wordt verstaan onder de webpagina: iedere webpagina
          van deze website waar deze disclaimer op van toepassing is en waarop
          uitgever deze disclaimer kan laten gelden;
        </p>
        <p>
          <em>
            <strong>Datum: 23 mei 2018.</strong>
          </em>
        </p>
      </div>
    </Layout>
  );
};

export async function getServerSideProps({ req, res, locale }) {
  if (!hasAuthToken(req)) {
    res.setHeader(
      'Cache-Control',
      'public, max-age=300, s-maxage=300, stale-while-revalidate=600'
    );
  }

  return {
    props: {
      ...(await serverSideTranslations(locale, ['common'])),
    },
  };
}

export default DisclaimerPage;
